var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuggestions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_3316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6405 7.31335C14.6767 7.87299 14.6767 8.43438 14.6405 8.99402C14.4578 11.822 12.2365 14.0754 9.44714 14.2607C8.48374 14.3242 7.5172 14.3242 6.5538 14.2607C6.21378 14.2373 5.87951 14.1608 5.56314 14.034C5.2218 13.894 5.05114 13.8234 4.9638 13.834C4.87714 13.8447 4.75114 13.9374 4.4998 14.1234C4.0558 14.45 3.49647 14.686 2.66647 14.6654C2.24714 14.6554 2.0378 14.65 1.9438 14.49C1.8498 14.33 1.96647 14.1087 2.20047 13.6654C2.52514 13.0507 2.73047 12.3467 2.41914 11.7834C1.88247 10.978 1.42714 10.024 1.36047 8.99402C1.32516 8.43458 1.32516 7.87346 1.36047 7.31402C1.54314 4.48602 3.76447 2.23269 6.5538 2.04735C6.9198 2.02335 6.95914 2.00802 7.3338 2.00269M7.99714 8.33335H8.0038M10.6611 8.33335H10.6671M5.3338 8.33335H5.3398",
    stroke: "#C6C0FA",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0106 1.59138C10.726 1.16472 11.35 1.33672 11.7246 1.61005C11.878 1.72272 11.9553 1.77872 12.0006 1.77872C12.046 1.77872 12.1226 1.72272 12.2766 1.61005C12.6513 1.33672 13.2753 1.16472 13.9906 1.59138C14.9293 2.15138 15.1413 3.99738 12.9773 5.55472C12.564 5.85138 12.3586 6.00005 12.0006 6.00005C11.6426 6.00005 11.4366 5.85138 11.0246 5.55472C8.85997 3.99738 9.07197 2.15072 10.0106 1.59138Z",
    stroke: "#C6C0FA",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_3316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuggestions);
export default __webpack_public_path__ + "static/media/suggestions.224cd9f751a3951504274f71e356663b.svg";
export { ForwardRef as ReactComponent };